export default __webpack_public_path__ + "static/Group 64-ff5fa0180c005a99f9c21a0a38102a9d.jpg";